import split_img from "./assets/split.jpg";
import break_up_img from "./assets/break_up.jpg";
import managing_lit_img from "./assets/managing_litigation.jpg";
import from_creativity_img from "./assets/from_creativity.jpg";
import brevity_img from "./assets/brevity.jpg";
import counterparts_img from "./assets/counterparts.jpg";
import signatories_img from "./assets/signatories.jpg";
import tinyplays_img from "./assets/tiny_plays.jpg";
import temple_hill_img from "./assets/temple_hill.jpg";
import moylurg_tower_img from "./assets/moylurg_tower.jpg";
import no_thanks_img from "./assets/no_thanks.jpg";
import marriage_img from "./assets/marriage.jpg";
import travel_abroad_img from "./assets/travel_abroad.jpg";
import pool_img from "./assets/pool.jpg";
import cao_img from "./assets/cao_choices.jpg";
import ten_signs_img from "./assets/ten_signs.jpg";
import school_over_img from "./assets/school_is_over.jpg";
import awaiting_decisions_img from "./assets/awaiting_decisions.jpg";
import sunday_img from "./assets/sunday_misc.jpg";
import rte_img from "./assets/rte_radio.jpg";
import tippFM_img from "./assets/tipp_fm.jpg";

export type Entry = {
  title: string;
  detail?: string;
  link?: string;
  kicker?: string;
  image?: string;
};

export const email = "rfehily@hotmail.com";

export const profiles = [
  { name: "ORCID", link: "https://orcid.org/0000-0001-7729-8827" },
  {
    name: "Google Scholar",
    link: "https://scholar.google.com/citations?hl=en&user=62_lQrAAAAAJ",
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/rachel-fehily-9b8b4618/",
  },
  { name: "Substack", link: "https://substack.com/@rachelfehily" },
  { name: "Instagram", link: "https://www.instagram.com/rachel_fehily/" },
  { name: "X", link: "https://x.com/rfehily" },
  { name: "Facebook", link: "https://www.facebook.com/rachel.fehily/" },
];

export const logos = [
  { name: "The New York Times", image: "/logos/nyt.svg" },
  { name: "University of Oxford", image: "/logos/oxford.svg" },
  { name: "Research Ireland", image: "/logos/research_ireland.svg" },
  { name: "Trinity College Dublin", image: "/logos/tcd.svg" },
  {
    name: "The Honorable Society of King’s Inns",
    image: "/logos/kings_inns.png",
    large: true,
  },
  { name: "The Irish Times", image: "/logos/irish_times.png" },
  { name: "RTÉ", image: "/logos/rte.svg" },
  {
    name: "University College Dublin",
    image: "/logos/ucd.svg",
    large: true,
  },
];

export const publications: Entry[] = [
  {
    title: "Grieving Time: A Radio Play",
    detail: "ABEI Journal, vol. 25, no. 2 (2023), pp. 63–74. Open access.",
    link: "https://doi.org/10.11606/issn.2595-8127.v25i2p63-74",
  },
  {
    title:
      "Chapter in Representations of Justice in Modern and Contemporary Literature, Film and Theatre",
    detail:
      "Edited by Maha Alatawi and Eamonn Jordan. Peter Lang, 2026. ISBN 9781803741529.",
    link: "https://www.peterlang.com/document/1690433",
  },
  {
    title: "Don’t Take It Personally",
    detail: "Short play in Fishamble’s Tiny Plays. New Island Books, 2024.",
    link: "https://www.fishamble.com/shop/playscripts/tiny-plays/",
  },
];

export const conferences: Entry[] = [
  {
    title: "The Reject Room",
    detail:
      "The Road Less Travelled? Irish-European Lives and Multi-Modal Approaches to Life-Writing, online, 2026.",
  },
  {
    title: "Urban Erosion: Memory, Landscape, and the Legacy of James Fehily",
    detail:
      "ASLE-UKI Biennial Conference: Erosion / Creimeadh, University of Galway, 2025.",
  },
  {
    title: "Stonehenge by Susan Spain-Dunk (1929)",
    detail:
      "Video. The Expansive Canvas: Large-Scale Form in the Music of 19th-Century Women Composers, Trinity College Dublin, 2025.",
    link: "https://www.youtube.com/watch?v=WiDzWRWliQ8",
  },
  {
    title:
      "Writing Home: Personal, Professional and Temporary Spaces During Cycles of Crisis, Change and Renewal in Baggotonia, Dublin, Ireland",
    detail:
      "IABA Europe 2025: Life-Writing and Social Transformation, University of Coimbra, 2025.",
  },
  {
    title:
      "From Brahmins to Dalits in one generation: how can theatre respond to the erasure of mixed-race identities in Ireland?",
    detail:
      "ISTR Conference: The End(s) of Empire: Place, Politics, Performance, IADT Dún Laoghaire, 2025.",
  },
  {
    title: "A Creative Based Cultural Production",
    detail:
      "Irish Humanities Alliance Annual Conference: New Perspectives on Irish Cultures, University of Limerick, 2024.",
  },
  {
    title: "The Erasure and Reconstruction of Identity Through Memoir",
    detail:
      "IABA World Conference: Fragmented Lives, University of Iceland, Reykjavík, 2024.",
  },
];

export const talks: Entry[] = [
  {
    title:
      "Press, People and Place in Baggotonia: The Legacy of Gayfield Press, Mary Lavin and Anne Yeats",
    detail:
      "The United Arts Club, Dublin, March 2026. The evening raised €650 for Women’s Aid.",
  },
  {
    title:
      "Doubly Othered: Legacy Issues for the Mixed-Race Children of Unmarried Mothers in Ireland Born Between 1940 and 1970",
    detail: "Irish Genealogical Research Society.",
  },
  {
    title:
      "Unmarried Mothers and their illegitimate mixed-race children in de Valera’s Ireland",
    detail:
      "Irish History Lecture Series, The Irish Cultural Centre, Hammersmith, London.",
  },
  {
    title: "Belonging in Baggotonia",
    detail: "Baggotonia Festival, Dublin, 2024 and 2025.",
  },
  {
    title: "Urban Erosion",
    detail: "University of the Third Age, Glasthule.",
  },
];

export const teaching: Entry[] = [
  {
    title: "ENG32840 Literature and Justice",
    detail:
      "An interdisciplinary third-year module at UCD School of English, Drama and Film, designed and co-convened in 2024 and 2025.",
  },
];

export const books = [
  {
    title: "Split: True Stories of Relationship Breakdown in Ireland",
    image: split_img,
    link: "https://www.amazon.com/Split-Stories-Relationship-Breakdown-Ireland/dp/1908023309",
  },
  {
    title:
      "Break Up, Don’t Crack Up: A Positive Plan for Your Separation or Divorce in Ireland",
    image: break_up_img,
    link: "https://www.amazon.com/Break-Dont-Crack-Positive-Separation-ebook/dp/B076JJFJ8M",
  },
  {
    title: "Managing Litigation for Your Business",
    image: managing_lit_img,
    link: "https://www.overdrive.com/media/1308001/managing-litigation-for-your-business",
  },
  {
    title: "Frank McGuinness: From Creativity to Legacy",
    image: from_creativity_img,
    link: "https://issuu.com/ucdoutreach/docs/ucdsc_mcguinness_exhibit_booklet",
  },
];

export const contributions: Entry[] = [
  {
    kicker: "Short story",
    title: "Co-Dependency",
    detail: "In Brevity Is the Soul: Wit from Lockdown Ireland.",
    image: brevity_img,
    link: "https://www.amazon.co.uk/Brevity-Soul-Wit-Lockdown-Ireland-ebook/dp/B08YNPVK4V",
  },
  {
    kicker: "Play",
    title: "Under Pressure",
    detail:
      "In Counterparts (The Stinging Fly), an anthology by Irish lawyer-writers published in aid of Peter McVerry Trust.",
    image: counterparts_img,
    link: "https://stingingfly.org/product/counterparts/",
  },
  {
    kicker: "Short play",
    title: "Don’t Take It Personally",
    detail:
      "In Tiny Plays for Ireland, from Fishamble in partnership with The Irish Times.",
    image: tinyplays_img,
    link: "https://www.fishamble.com/shop/playscripts/tiny-plays/",
  },
  {
    kicker: "Monologue",
    title: "Thomas Clarke",
    detail:
      "In Signatories (UCD Press), eight writers’ responses to the centenary of the 1916 Rising.",
    image: signatories_img,
    link: "https://www.ucdpress.ie/display.asp?isbn=9781910820100",
  },
];

export const articles: Entry[] = [
  {
    kicker: "The New York Times: Modern Love",
    title: "Tiny Love Stories: ‘Why Don’t You Both Get In?’",
    detail:
      "Modern Love in miniature: reader-submitted stories of no more than 100 words",
    link: "https://www.nytimes.com/2026/06/17/style/tiny-modern-love-stories-why-dont-you-both-get-in.html",
  },
  {
    kicker: "The Irish Times: Opinion",
    title:
      "Why are the experiences of people, like me, who were resident in Temple Hill forgotten?",
    detail:
      "Residents of the old St Patrick’s Infant and Dietetic Hospital are excluded from redress schemes despite its role in adoptions",
    image: temple_hill_img,
    link: "https://www.irishtimes.com/opinion/2025/07/16/rachel-fehily-why-are-the-experiences-of-people-born-like-me-in-temple-hill-forgotten/",
  },
  {
    kicker: "The Roscommon Herald: News",
    title:
      "From monstrosity to TikTok sensation: How Moylurg Tower refused to be forgotten",
    detail:
      "During the recent ‘Night and Day Festival’ the tower was lit up and used as a stage for musicians",
    image: moylurg_tower_img,
    link: "https://www.roscommonherald.ie/news/from-monstrosity-to-tik-tok-sensation-how-moylurg-tower-refused-to-be-forgotten_arid-68775.html",
  },
  {
    kicker: "Irish Examiner: Letters to the Editor",
    title:
      "Temple Hill survivors have to go to court to get into redress scheme",
    detail:
      "A letter on the exclusion of Temple Hill from the mother and baby institutions payment scheme",
    link: "https://www.irishexaminer.com/opinion/yourview/arid-41641831.html",
  },
  {
    kicker: "The Irish Times: Opinion",
    title: "No thanks for carers who save the HSE €4bn a year",
    detail:
      "We have allowed yet another unpaid, exploited group to emerge in Irish society",
    image: no_thanks_img,
    link: "https://www.irishtimes.com/opinion/rachel-fehily-no-thanks-for-carers-who-save-hse-4bn-a-year-1.2892600",
  },
  {
    kicker: "The Irish Times: Opinion",
    title: "Now we have marriage equality, how about equality in marriage?",
    detail:
      "In a married relationship economic power needs to be carefully balanced",
    image: marriage_img,
    link: "https://www.irishtimes.com/opinion/now-we-have-marriage-equality-how-about-equality-in-marriage-1.2279309",
  },
  {
    kicker: "The Irish Times: Health",
    title: "Preparing for travel abroad when mobility is restricted",
    detail:
      "Prepare as much as you can in advance of your holiday so there isn’t a last-minute panic",
    image: travel_abroad_img,
    link: "https://www.irishtimes.com/life-and-style/health-family/preparing-for-travel-abroad-when-mobility-is-restricted-1.2759161",
  },
  {
    kicker: "The Irish Times: People",
    title: "Summer Snaps: A Pool in 1970s Ireland",
    detail:
      "The Clyde Road water feature was an attraction for our friends and cousins",
    image: pool_img,
    link: "https://www.irishtimes.com/life-and-style/people/summer-snaps-a-pool-in-1970s-ireland-1.1890309",
  },
  {
    kicker: "The Irish Times: Opinion",
    title: "Redress could have been far easier for abuse victims",
    detail:
      "Was an adversarial legal approach the best way to handle applications to the abuse redress board? I don’t think so",
    link: "https://www.irishtimes.com/opinion/redress-could-have-been-far-easier-for-abuse-victims-1.648193",
  },
  {
    kicker: "The Irish Times: Leaving Cert Parent’s Diary",
    title: "I’m wistful for the random way we made CAO choices in the 80s",
    detail:
      "In the absence of psychometric tests or college open days, we took a more anarchic approach to life-defining career decisions",
    image: cao_img,
    link: "https://www.irishtimes.com/news/education/parent-s-diary-i-m-wistful-for-the-random-way-we-made-cao-choices-in-the-80s-1.3776130",
  },
  {
    kicker: "The Irish Times: Leaving Cert Parent’s Diary",
    title:
      "The sight of my son playing Fortnite is enough to send me into a panic",
    detail:
      "10 tell-tale signs the State exams are looming all too soon in my house",
    image: ten_signs_img,
    link: "https://www.irishtimes.com/news/education/leaving-cert-parents-diary-the-sight-of-my-son-playing-fortnite-is-enough-to-send-me-into-a-panic-1.3814339",
  },
  {
    kicker: "The Irish Times: Leaving Cert Parent’s Diary",
    title: "School is over. Now it’s time to let go",
    detail:
      "We have to stand back and let them make their choices and their mistakes",
    image: school_over_img,
    link: "https://www.irishtimes.com/news/education/leaving-cert-parent-s-diary-school-is-over-now-it-s-time-to-let-go-1.3914677",
  },
  {
    kicker: "The Irish Times: Leaving Cert Parent’s Diary",
    title: "Limbo of waiting for Leaving Cert results is almost over",
    detail:
      "We are awaiting decisions about the future that are out of our hands",
    image: awaiting_decisions_img,
    link: "https://www.irishtimes.com/news/education/limbo-of-waiting-for-leaving-cert-results-is-almost-over-1.3983117",
  },
];

export const radio = [
  {
    title: "Pelican House",
    image: sunday_img,
    link: "https://www.rte.ie/radio/radio1/clips/21243427/",
  },
  {
    title: "Grieving Time",
    image: rte_img,
    link: "https://www.rte.ie/radio/dramaonone/1241306-grieving-time-by-rachel-fehily",
  },
  {
    title: "Ecstatic Dancing",
    image: sunday_img,
    link: "https://www.rte.ie/radio/radio1/clips/21181362/",
  },
  {
    title: "I am Irish",
    image: sunday_img,
    link: "https://www.rte.ie/radio/radio1/clips/21145017/",
  },
  {
    title: "Tipp FM Advice Slot",
    image: tippFM_img,
    link: "https://www.youtube.com/watch?v=ZACkHuqFVfs",
  },
  {
    title: "Love of My Life",
    image: sunday_img,
    link: "https://www.rte.ie/radio/radio1/clips/21138082/",
  },
  {
    title: "Your Relationship in a Pandemic",
    image: rte_img,
    link: "https://www.rte.ie/radio/radio1/clips/21910741/",
  },
  {
    title: "Chapels on San Giorgio di Maggiore",
    image: sunday_img,
    link: "https://www.rte.ie/radio/radio1/clips/21402833/",
  },
];

export const film: Entry[] = [
  {
    title: "Theocracy – The Emigrant’s Artist",
    detail:
      "Documentary directed by Sé Merry Doyle (Loopline Film). On-screen participant and archivist. Premiered at Cork International Film Festival, November 2025, with a UK premiere at the Kiln Theatre, London.",
    link: "https://www.imdb.com/title/tt38997322/",
  },
  {
    title: "The Creative Palette: Susan Spain-Dunk",
    detail: "Short film made for Culture Night, September 2025.",
    link: "https://www.youtube.com/watch?v=WiDzWRWliQ8",
  },
  {
    title: "Irish Creative PhD Podcast",
    detail:
      "Host of a podcast on creativity and education, recorded as part of her PhD at UCD.",
    link: "https://shows.acast.com/irish-creative-phd-podcast",
  },
  {
    title: "The Bright Side of the Road",
    detail:
      "Interview about her PhD research on Portobello Radio’s programme for the Irish diaspora in London.",
  },
];
